import { render, staticRenderFns } from "./ontick-button.component.vue?vue&type=template&id=1bcb5d59&scoped=true"
import script from "./ontick-button.component.vue?vue&type=script&lang=js"
export * from "./ontick-button.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-button.component.vue?vue&type=style&index=0&id=1bcb5d59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb5d59",
  null
  
)

export default component.exports